import { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";

import "moment/locale/pt-br";
import "./styles.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChartBar,
    faCircle,
    faExchangeAlt,
    faFilter,
    faHashtag,
    faTimes,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";

import Table from "../../../../Components/Table";
import StickyToolbar from "../../../../Components/StickyToolbar";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";

import {
    ExportarExcelAtendimentosCobrancaController,
    ListarAtendimentosCobrancaTransferirController,
    ListarAtendimentosController,
} from "../../../../Controllers/Cobranca/GestaoAtendimento/GestaoAtendimentoController";
import {
    IAtendimentoCobranca,
    ListarAtendimentosRequest,
    ListarAtendimentosResponse,
} from "../../../../Interfaces/Cobranca/GestaoAtendimento/GestaoAtendimentoInterface";
import InternalError from "../../../Errors/InternalError";
import AtendimentoCard, {
    getAtendimentoTableViewColumns,
} from "../../../../Components/CardsPages/Atendimento";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import { TModoGestaoAtendimento } from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import {
    ListarEmpreendimentosComObraController,
    ListarUnidadesPorEmpreendimentoController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";

import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import TransferirAtendimento from "../../../../Components/CardsPages/Atendimento/TransferirAtendimento";
import { ACESSOS } from "../../../../Routes/Acessos";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useUserInfor } from "../../../../Context/User";
import TransferirTodosAtendimento from "../../../../Components/CardsPages/Atendimento/TransferirTodosAtendimentos";
import { ExcluirAtendimentoController } from "../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import Swal from "sweetalert2";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";

interface FilterFormDataInterface {
    data_inicio: string;
    data_fim: string;
    busca?: string;
    DS_STATUS_CASO?: number;
    ID_EMPREENDIMENTO?: number;
    ID_PRODUTO?: number;
    ID_UNIDADE?: number;
    ID_USUARIO?: number;
    ID_CASO?: number;
    DS_NOME_CONTA?: string;
    DS_NOME_CONTATO?: string;
    ID_TIPO_CANAL_ATENDIMENTO?: number;
    PESQUISA?: string;
    FL_CONTEM?: boolean;
}

interface IAtendimentosCobrancaProps {
    atendimento: TModoGestaoAtendimento;
}

function AtendimentosCobranca(props: IAtendimentosCobrancaProps) {
    moment.locale("pt-br");
    const FILTRO_GESTAO_ATENDIMENTOS_COBRANCA = sessionStorage.getItem(
        "FILTRO_GESTAO_ATENDIMENTOS_COBRANCA"
    );

    const todaysDate = new Date();
    //instancia um objeto date de 3 meses antes da data de hoje
    const pastDate = new Date(new Date().setMonth(todaysDate.getMonth() - 3));
    const filtroInicial = {
        data_inicio: pastDate.toISOString().substring(0, 10),
        data_fim: todaysDate.toISOString().substring(0, 10),
        busca: "",
    };

    const [lstAtendimentos, setLstAtendimento] =
        useState<ListarAtendimentosResponse>();
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(false);
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    // const ultimaPesquisaRef = useRef("");
    // const [pesquisaText, setPesquisaText] = useState("");
    // const [naoContem, setNaoContem] = useState<boolean>(true);

    /**filtro */
    const filter = useRef<FilterFormDataInterface>(
        FILTRO_GESTAO_ATENDIMENTOS_COBRANCA
            ? JSON.parse(FILTRO_GESTAO_ATENDIMENTOS_COBRANCA)
            : filtroInicial
    );

    const FormMethods = useForm<FilterFormDataInterface>();
    const { register, handleSubmit, reset } = FormMethods;
    const { UserInfor } = useUserInfor();
    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    const update = useCallback(() => {
        updateAtendimentos(
            {
                ...filter.current,
                DS_FILTRO: filter.current.busca,
                DT_PERIODO_INICIO: filter.current.data_inicio,
                DT_PERIODO_FIM: filter.current.data_fim,
                NR_PAGINA: 1,
                FL_STATUS:
                    filter.current.DS_STATUS_CASO === 0
                        ? false
                        : filter.current.DS_STATUS_CASO === 1
                            ? true
                            : undefined,
                ID_CONTA: 0,
                ID_CASO: filter.current.ID_CASO || 0,
                ID_TIPO_CANAL_ATENDIMENTO:
                    filter.current.ID_TIPO_CANAL_ATENDIMENTO || 0,
            },
            props.atendimento
        );
    }, [props.atendimento]);

    useEffect(() => {
        update();
    }, [props.atendimento, update]);

    const updateAtendimentos = (
        data: ListarAtendimentosRequest,
        modo: TModoGestaoAtendimento
    ) => {
        setLoading(true);
        ListarAtendimentosController(data, modo)
            .then((res) => {
                setLoading(false);
                setTotalPaginas(res.NR_TOTAL_PAGINAS);
                setLstAtendimento(res);
            })
            .catch((err) => {
                setLoading(false);
                setErr(true);
            });
    };
    const handleDateChange = (formData: FilterFormDataInterface) => {
        filter.current = {
            ...formData,
        };
        sessionStorage.setItem(
            "FILTRO_GESTAO_ATENDIMENTOS_COBRANCA",
            JSON.stringify({ ...formData })
        );

        updateAtendimentos(
            {
                ...filter.current,
                DS_FILTRO: filter.current.busca,
                DT_PERIODO_INICIO: filter.current.data_inicio,
                DT_PERIODO_FIM: filter.current.data_fim,
                NR_PAGINA: 1,
                FL_STATUS:
                    filter.current.DS_STATUS_CASO === 0
                        ? false
                        : filter.current.DS_STATUS_CASO === 1
                            ? true
                            : undefined,
                ID_CONTA: 0,
                ID_CASO: filter.current.ID_CASO || 0,
                ID_TIPO_CANAL_ATENDIMENTO:
                    filter.current.ID_TIPO_CANAL_ATENDIMENTO || 0,
            },
            props.atendimento
        );
    };

    // function handleSearch(
    //     searchValue: string,
    //     newState: IPropsTableChange
    //     // contem: boolean
    // ) {
    //     ultimaPesquisaRef.current = searchValue;

    //     setTimeout(() => {
    //         if (ultimaPesquisaRef.current === searchValue) {
    //             setFilter({
    //                 ...filter,
    //                 data_inicio: filter?.data_inicio ?? "",
    //                 data_fim: filter?.data_fim ?? "",
    //                 PESQUISA: newState.searchText,
    //                 // FL_CONTEM: naoContem,
    //             });
    //             setPage(newState.page);
    //         }
    //     }, 1500);
    // }

    const Filter: JSX.Element = (
        <form
            className="form-group row"
            onSubmit={handleSubmit(handleDateChange)}
        >
            <div className="col-12 mt-3">
                <label>Data Inicial</label>
                <input
                    className="form-control"
                    type="date"
                    defaultValue={filter?.current.data_inicio}
                    name="data_inicio"
                    ref={register({
                        required: "Insira a data inicial",
                    })}
                />
            </div>
            <div className="col-12 mt-3">
                <label>Data Final</label>
                <input
                    className="form-control"
                    type="date"
                    defaultValue={filter?.current.data_fim}
                    name="data_fim"
                    ref={register({
                        required: "Insira a data final",
                    })}
                />
            </div>
            {props.atendimento !== "USUARIO" && (
                <div className="col-12 mt-3">
                    <label>Status do Caso</label>
                    <select
                        className="form-control"
                        name="DS_STATUS_CASO"
                        defaultValue={filter?.current.DS_STATUS_CASO}
                        ref={register({
                            valueAsNumber: true,
                        })}
                    >
                        <option></option>
                        <option value={0}>Aberto</option>
                        <option value={1}>Fechado</option>
                    </select>
                </div>
            )}

            <div className="col-12 mt-3">
                <LazySelect
                    label={"Empreendimento"}
                    className="form-control"
                    name="ID_EMPREENDIMENTO"
                    defaultValue={filter?.current.ID_EMPREENDIMENTO}
                    registerOptions={{
                        valueAsNumber: true,
                    }}
                    {...FormMethods}
                    controller={ListarEmpreendimentosComObraController}
                    getDS={(e) => e.DS_EMPREENDIMENTO}
                    getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                    ref={register()}
                >
                    <option value={0}></option>
                </LazySelect>
            </div>
            <div className="col-12 mt-3">
                <LazySelect
                    label={"Unidade"}
                    className="form-control"
                    name="ID_UNIDADE"
                    registerOptions={{
                        valueAsNumber: true,
                    }}
                    defaultValue={filter?.current.ID_UNIDADE}
                    controller={ListarUnidadesPorEmpreendimentoController}
                    fatherName={"ID_EMPREENDIMENTO"}
                    getDS={(u) => u.DS_UNIDADE}
                    getKeyValue={(u) => u.ID_UNIDADE}
                    ref={register()}
                    {...FormMethods}
                >
                    <option value={0}></option>
                </LazySelect>
            </div>
            {props.atendimento !== "USUARIO" && (
                <div className="col-12 mt-3">
                    <label>Atendente</label>
                    <LazySelect
                        className="form-control"
                        name="ID_USUARIO"
                        defaultValue={filter?.current.ID_USUARIO}
                        registerOptions={{
                            valueAsNumber: true,
                        }}
                        controller={ListarUsuariosController}
                        getDS={(u) => u.DS_NOME}
                        filter={(u) => u.FL_ATIVO}
                        getKeyValue={(u) => u.ID_USUARIO}
                        ref={register()}
                        {...FormMethods}
                    >
                        <option value={0}></option>
                    </LazySelect>
                </div>
            )}
            <div className="col-12 mt-3">
                <label>Protocolo</label>
                <input
                    className="form-control"
                    type="number"
                    defaultValue={filter?.current.ID_CASO}
                    name="ID_CASO"
                    ref={register({
                        valueAsNumber: true,
                    })}
                />
            </div>
            <div className="col-12 mt-3">
                <label>Cliente</label>
                <input
                    className="form-control"
                    type="text"
                    defaultValue={filter?.current.DS_NOME_CONTA}
                    name="DS_NOME_CONTA"
                    ref={register()}
                />
            </div>
            <div className="col-12 mt-3">
                <label>Contato</label>
                <input
                    className="form-control"
                    type="text"
                    defaultValue={filter?.current.DS_NOME_CONTATO}
                    name="DS_NOME_CONTATO"
                    ref={register()}
                />
            </div>
            <div className={`col-12 mt-3 `}>
                <LazySelect
                    className="form-control"
                    label="Canal de Atendimento"
                    name="ID_TIPO_CANAL_ATENDIMENTO"
                    controller={listarCanalAtendimento}
                    getKeyValue={(u) => u.ID_TIPO_CANAL_ATENDIMENTO}
                    getDS={(u) => u.DS_TIPO_CANAL_ATENDIMENTO}
                    defaultValue={filter?.current.ID_TIPO_CANAL_ATENDIMENTO}
                    ref={register()}
                    {...FormMethods}
                >
                    <option></option>
                </LazySelect>
            </div>
            {/* <div className={`col-12 mt-3 `}>
                <label>Não contém</label>
                <div className="d-flex justify-content-start">
                    <Switch
                        color="success"
                        labelPosition="top"
                        type="checkbox"
                        name="FL_CONTEM"
                        onChange={(e) => {
                            if (e.target.checked === true) {
                                Swal.fire({
                                    title: "Ao ativar a opção 'Não Contém', sua pesquisa retornará todos os registros que não têm o texto especificado.",
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Ok!",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                    },
                                });
                                setNaoContem(false);
                            } else {
                                setNaoContem(true);
                            }
                        }}
                        defaultChecked={false}
                        ref={register()}
                    />
                </div>
            </div> */}
            <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                <button
                    type="submit"
                    className="btn btn-block btn-outline-dark"
                >
                    <FontAwesomeIcon icon={faFilter} className="mr-2" />
                    Filtrar
                </button>
            </div>
            <div className="col-12 d-flex align-items-end justify-content-start">
                <button
                    type="button"
                    onClick={() => {
                        window.sessionStorage.removeItem(
                            "FILTRO_GESTAO_ATENDIMENTOS_COBRANCA"
                        );
                        reset(filtroInicial);
                    }}
                    className="btn btn-block btn-outline-danger mt-2"
                >
                    <FontAwesomeIcon icon={faTimes} className="mr-2" />
                    Limpar Filtros
                </button>
            </div>
        </form>
    );

    function rowAtendimento(cell: any, row: IAtendimentoCobranca) {
        const atendimento = row;
        return (
            <AtendimentoCard
                atendimento={row}
                setModal={setModal}
                setShow={setShow}
                moduloAtendimento="Cobranca"
            >
                <div className="d-flex flex-column mt-3 flex-grow-1">
                    <label className="text-center text-dark font-weight-bold my-1 mr-5">
                        Cobrança
                    </label>
                    <div className="border-right border-left fixheigth border-3 border-warning">
                        <div className="d-flex flex-wrap align-items-center justify-content-center h-100">
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Data da venda
                                    </div>
                                    <label>
                                        {moment(
                                            atendimento.COBRANCA.DT_VENDA
                                        ).format("L")}
                                    </label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Valor em aberto
                                    </div>
                                    <label>
                                        {
                                            atendimento.COBRANCA
                                                .NR_PARCELAS_EM_ABERTO_ABERTURA
                                        }{" "}
                                        x{" "}
                                        {formatMoneyReais(
                                            atendimento.COBRANCA
                                                .VL_PARCELAS_EM_ABERTO_ABERTURA
                                        )}
                                    </label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Resultado do Contato
                                    </div>
                                    <label>
                                        {
                                            atendimento.COBRANCA
                                                .DS_RESULTADO_CONTATO
                                        }
                                    </label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Tempo de Retorno
                                    </div>
                                    <label>
                                        {
                                            atendimento.COBRANCA
                                                .NR_TEMPO_RETORNO_FILA
                                        }{" "}
                                        {atendimento.COBRANCA
                                            .NR_TEMPO_RETORNO_FILA === 1
                                            ? "hora"
                                            : "horas"}
                                    </label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Classificação
                                    </div>
                                    <label>
                                        {
                                            atendimento.COBRANCA
                                                .DS_CLASSIFICACAO_CONTRATO_ABERTURA
                                        }
                                    </label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Status Escritura
                                    </div>
                                    <label>
                                        {
                                            atendimento.COBRANCA
                                                .DS_STATUS_ESCRITURA_ABERTURA
                                        }
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AtendimentoCard>
        );
    }
    //tabela
    const atendimentoColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO",
            text: "ID",
            formatter: rowAtendimento,
            headerClasses: "d-none",
        },
    ];
    const tableviewColumns =
        getAtendimentoTableViewColumns<IAtendimentoCobranca>("COBRANCA", [
            {
                dataField: "COBRANCA.DT_VENDA",
                text: "Data da venda",
                formatter: (c) => new Date(c).toLocaleDateString(),
            },
            {
                dataField: "COBRANCA.VL_PARCELAS_EM_ABERTO_ABERTURA",
                text: "Valor em aberto",
                formatter: (c, row) =>
                    `${row.COBRANCA.NR_PARCELAS_EM_ABERTO_ABERTURA
                    } x ${formatMoneyReais(c)}`,
            },
            {
                dataField: "COBRANCA.DS_RESULTADO_CONTATO",
                text: "Resultado do Contato",
            },
            {
                dataField: "COBRANCA.NR_TEMPO_RETORNO_FILA",
                text: "Tempo de Retorno",
                formatter: (c) => `${c} ${c === 1 ? "hora" : "horas"}`,
            },
            {
                dataField: "COBRANCA.DS_CLASSIFICACAO_CONTRATO_ABERTURA",
                text: "Classificação",
            },
            {
                dataField: "COBRANCA.DS_STATUS_ESCRITURA_ABERTURA",
                text: "Status Escritura",
            },
            {
                dataField: "",
                text: "",
                isDummyField: true,
                formatter: (_, row) => (
                    <div className="d-flex g-2 p-2">
                        {UserInfor.FUNCOES.some(
                            (f: { NM_FUNCAO: string }) =>
                                f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                        ) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="transferir-tooltip">
                                            Transferir Atendimento
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        className="btn btn-icon btn-outline-warning"
                                        onClick={() => {
                                            setModal({
                                                Component: () => (
                                                    <TransferirAtendimento
                                                        ID_CASO={row.ID_CASO}
                                                        ID_TIPO_CASO={
                                                            ACESSOS.COBRANCA
                                                                .ID_MODULO
                                                        }
                                                        setShow={setShow}
                                                        update={() => {
                                                            update();
                                                        }}
                                                    />
                                                ),
                                                IconHeader: faExchangeAlt,
                                                headerComponent:
                                                    "Transferir Atendimento",
                                            });
                                            setShow(true);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faExchangeAlt} />
                                    </button>
                                </OverlayTrigger>
                            )}
                        {UserInfor.FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_EXCLUIR_CASO"
                        ) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="historico-tooltip">
                                            Excluir Atendimento
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        className="btn btn-icon btn-outline-dark"
                                        onClick={() => {
                                            Swal.fire({
                                                title: `Deseja excluir esse Atendimento? <br/> <br/> Caso: ${row.ID_CASO}`,
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Sim!",
                                                showCancelButton: true,
                                                cancelButtonText:
                                                    "<i class='la la-thumbs-down'></i> Não",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                    cancelButton: "btn btn-default",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    ExcluirAtendimentoController(
                                                        row.ID_CASO,
                                                        UserInfor.ID_USUARIO ?? 0
                                                    ).then(() => {
                                                        update();
                                                    });
                                                }
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </OverlayTrigger>
                            )}
                    </div>
                ),
            },
        ]);

    return (
        <div className="card card-custom">
            {err ? (
                <InternalError />
            ) : (
                <div>
                    {loading ? (
                        <></>
                    ) : (
                        <div className="d-flex flex-row px-4 pt-4 justify-content-around">
                            <div className="px-4 pt-1 pb-2 bg-primary rounded text-white">
                                <div className="d-flex align-items-center">
                                    <span className="svg-icon svg-icon-2x">
                                        <FontAwesomeIcon icon={faChartBar} />
                                    </span>
                                    <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                                        {lstAtendimentos?.NR_CASOS ?? 0}
                                    </span>
                                </div>
                                <span className="font-weight-bold font-size-sm">
                                    Total de Atendimentos
                                </span>
                            </div>
                            <div className="px-4 pt-1 pb-2 bg-info rounded text-white">
                                <div className="d-flex align-items-center">
                                    <span className="svg-icon svg-icon-2x">
                                        <FontAwesomeIcon icon={faCircle} />
                                    </span>
                                    <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                                        {lstAtendimentos?.NR_CASOS_EM_DIA ?? 0}
                                    </span>
                                </div>
                                <span className="font-weight-bold font-size-sm">
                                    Atendimento no Prazo
                                </span>
                            </div>
                            <div className="px-4 pt-1 pb-2 bg-danger rounded text-white">
                                <div className="d-flex align-items-center">
                                    <span className="svg-icon svg-icon-2x">
                                        <FontAwesomeIcon icon={faHashtag} />
                                    </span>
                                    <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                                        {lstAtendimentos?.NR_CASOS_EM_ATRASO ??
                                            0}
                                    </span>
                                </div>
                                <span className="font-weight-bold font-size-sm">
                                    Atendimento Atrasados
                                </span>
                            </div>
                        </div>
                    )}

                    <Table
                        columns={atendimentoColumns}
                        data={lstAtendimentos?.LISTA_ATENDIMENTOS ?? []}
                        keyField="ID_CASO"
                        onTableChange={(type, newState) => {
                            updateAtendimentos(
                                {
                                    ...filter.current,
                                    NR_PAGINA: newState.page,
                                    DS_FILTRO: filter.current.busca,
                                    DT_PERIODO_INICIO:
                                        filter.current.data_inicio,
                                    DT_PERIODO_FIM: filter.current.data_fim,
                                    FL_STATUS:
                                        filter.current.DS_STATUS_CASO === 0
                                            ? false
                                            : filter.current.DS_STATUS_CASO ===
                                                1
                                                ? true
                                                : undefined,
                                    ID_CONTA: 0,
                                    ID_CASO: filter.current.ID_CASO ?? 0,
                                    ID_TIPO_CANAL_ATENDIMENTO:
                                        filter.current
                                            .ID_TIPO_CANAL_ATENDIMENTO || 0,
                                },
                                props.atendimento
                            );
                        }}
                        tableView={{
                            columns: tableviewColumns,
                            noSort: true,
                            sizePerPage: 10,
                            cancelYScroll: true,
                            defaultStyle: true,
                            defaultClasses: "p-1",
                        }}
                        remote={{ pagination: true }}
                        totalPages={totalPaginas}
                        loading={loading}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhum Atendimento encontrado
                            </div>
                        )}
                        noHover
                        noSearch
                        bordered={false}
                    />
                    <ExportExcel
                        baixarExcelController={async () =>
                            ExportarExcelAtendimentosCobrancaController(
                                {
                                    ...filter.current,
                                    DS_FILTRO: filter.current.busca,
                                    DT_PERIODO_INICIO:
                                        filter.current.data_inicio,
                                    DT_PERIODO_FIM: filter.current.data_fim,
                                    NR_PAGINA: 1,
                                    FL_STATUS:
                                        filter.current.DS_STATUS_CASO === 0
                                            ? false
                                            : filter.current.DS_STATUS_CASO ===
                                                1
                                                ? true
                                                : undefined,
                                    ID_CONTA: 0,
                                    ID_CASO: filter.current.ID_CASO || 0,
                                    ID_TIPO_CANAL_ATENDIMENTO:
                                        filter.current
                                            .ID_TIPO_CANAL_ATENDIMENTO || 0,
                                },
                                props.atendimento
                            )
                        }
                        nomeArquivo={`Atendimentos_Cobranca_${filter.current.data_inicio}_${filter.current.data_fim}`}
                    />

                    <TransferirTodosAtendimento
                        ID_TIPO_CASO={ACESSOS.COBRANCA.ID_MODULO}
                        filter={filter.current}
                        setShow={setShow}
                        update={() => {
                            update();
                        }}
                        controller={() =>
                            ListarAtendimentosCobrancaTransferirController(
                                {
                                    ...filter.current,
                                    NR_PAGINA: 0,
                                    DS_FILTRO: filter.current.busca,
                                    DT_PERIODO_INICIO:
                                        filter.current.data_inicio,
                                    DT_PERIODO_FIM: filter.current.data_fim,
                                    FL_STATUS:
                                        filter.current.DS_STATUS_CASO === 1
                                            ? true
                                            : filter.current.DS_STATUS_CASO ===
                                                0
                                                ? false
                                                : undefined,
                                    ID_CONTA: 0,
                                    ID_CASO: filter.current.ID_CASO ?? 0,
                                    ID_TIPO_CANAL_ATENDIMENTO:
                                        filter.current
                                            .ID_TIPO_CANAL_ATENDIMENTO || 0,
                                },
                                props.atendimento
                            )
                        }
                    />
                    <StickyToolbar
                        Filters={Filter}
                        active={!!FILTRO_GESTAO_ATENDIMENTOS_COBRANCA}
                    />
                    <ModalComponent
                        show={show}
                        setShow={setShow}
                        ModalComponent={modal}
                    />
                </div>
            )}
        </div>
    );
}

export default AtendimentosCobranca;
